export default __webpack_public_path__ + "static/media/iconExpert.346c9ee3.png";